import { cn } from '@/lib';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'destructive' | 'default';
}

/**
 * @component Button
 * @description Base button component with consistent styling and behavior.
 *
 * @props
 *   children (ReactNode, required) - Content to render inside the button.
 */
export function Button({ children, className, variant = 'default', ...props }: ButtonProps) {

  let styleClassName = ""
  switch (variant) {
    case 'primary':
      styleClassName = 'border-primary text-onsurface hover:bg-primary/10'
      break
    case 'secondary':
      styleClassName = 'border-secondary text-onsurface hover:bg-secondary/10'
      break
    case 'destructive':
      styleClassName = 'border-error text-error hover:bg-error/10'
      break
    case 'default':
    default:
      styleClassName = 'border-border text-onsurface hover:bg-surface-darker'
  }

  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-lg border px-3 py-1.5 text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50',
        styleClassName,
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
